<template>
<div>
    <div class="section-13">
        <div class="form-3-header-div-2">
            <div class="div-block-2319">
                <a href="#" class="w-inline-block"><img loading="lazy" src="@/assets/images/NewSelf_Logo.webp" alt="" class="image-715"></a>
                <div class="div-block-967">
                    <div class="text-block-152 top">STEP</div>
                    <div class="text-block-151">3 <span class="text-span-72">of</span> 3</div>
                    <div class="text-block-152 bottom">COMPLETE</div>
                </div>
            </div>
        </div>
        <div class="div-block-181">
            <div class="girl-div"></div>
        </div>
    </div>
    <section>
        <div class="step-form-wrap">
            <div class="next-steps-slide">
                <div class="div-block-2323"><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-718">
                    <div class="text-block-1810">Your Visit Has Been Submitted</div>
                </div>
                <div class="text-block-1811">What Happens Next:</div>
                <div class="steps-main-div">
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/Doctor_newself.webp')" loading="lazy" sizes="(max-width: 755px) 100vw, 755px" :srcset="require('@/assets/images/Doctor_newself-p-500.webp') + ' 500w, ' + require('@/assets/images/Doctor_newself.webp') + ' 755w'" alt="" class="process-step-img-copy doc"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Medical Review</strong><br></div>
                                        <div class="process-step-sub-copy">A licensed provider is reviewing your information and video to determine appropriate care.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">1</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">In Process</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/StepsImage_phonechat.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_phonechat-p-500.webp') + ' 500w, ' + require('@/assets/images/StepsImage_phonechat-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_phonechat.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Provider Chat</strong><br></div>
                                        <div class="process-step-sub-copy">On the next screen, you’ll access your dashboard and secure chat to message your provider.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">2</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">2 Mins</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/StepsImage_logos.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_logos-p-500.png') + ' 500w, ' + require('@/assets/images/StepsImage_logos-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_logos.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Treatment &amp; Pharmacy</strong><br></div>
                                        <div class="process-step-sub-copy">Your treatment plan is finalized and prescriptions are sent to your selected pharmacy if appropriate.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">3</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">Today</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/StepsImage_phonesupport.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_phonesupport-p-500.webp') + ' 500w, ' + require('@/assets/images/StepsImage_phonesupport.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Follow-Up Support</strong><br></div>
                                        <div class="process-step-sub-copy">After starting medication, use secure chat to ask questions or share updates with your provider.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">4</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">Today</div>
                        </div>
                    </div>
                </div>
                <a href="#" @click.prevent="goToDash" class="form-button-1 w-button">Continue <span class="text-span-461">-&gt;</span></a>
            </div>
        </div>
    </section>
</div>
</template>
<script>
export default {
    name: 'urgentCareEndStep',
    methods: {
        goToDash() {
            this.$router.push(`/home`);
        }
    }
}
</script>
